<template>
  <div class="fontlao">
    <NavBar />
    <LoadingOverlay v-if="loading" />
    <SnackbarSuccess v-if="alertSucces" />
    <SnackbarFailed v-if="alertFail" />
  </div>
</template>

<script>
import LoadingOverlay from "../alert/loading-overlay.vue";
import SnackbarFailed from "../alert/Snackbar-Failed.vue";
import SnackbarSuccess from "../alert/Snackbar-Success.vue";
import NavBar from "../portal/NavBar.vue";
export default {
  name: "LayoutDefaults",
  components: {
    NavBar,
    LoadingOverlay,
    SnackbarSuccess,
    SnackbarFailed,
  },
  computed: {
    alertSucces: {
      get() {
        return this.$store.state.snackbarSuccess;
      },
    },
    alertFail: {
      get() {
        return this.$store.state.snackbarFailed;
      },
    },
    loading: {
      get() {
        return this.$store.state.LoadingOverlay;
      },
    },
  },
};
</script>

<style>
.fontlao {
  font-family: phetsarath ot !important;
}
</style>
